<template>
    <Dropdown class="DshColorPanel" :trigger="trigger" :placement="placement" :transfer="transfer">
        <Icon class="DshColorPanel-rel" :type="dropdownObj.icon" :size="dropdownObj.size" :color="dropdownObj.color" />

        <DropdownMenu slot="list" class="DshColorPanel-list">
            <DropdownItem
                v-for="dropdownItem in list"
                :key="dropdownItem._id || dropdownItem.type"
                class="DshColorPanel-list-item"
                :selected="dropdownItem.selected"
                @click.native="dispatchEvent(dropdownItem)"
            >
                <span
                    class="DshColorPanel-list-item-small"
                    :style="{background:dropdownItem}"
                 ></span>
                <span class="DshColorPanel-list-item-big" :style="{borderColor:dropdownItem}"></span>
            </DropdownItem>
        </DropdownMenu>
    </Dropdown>
</template>

<script>
    export default {
        name: "DshColorPanel",
        props: {
            dropdownObj: {
                type: Object,
                default () {
                    return {
                        icon: "ios-more",
                        size: 18,
                        showDropdownItemIcon: true
                    };
                }
            },
            list: {
                type: Array,
                default () {
                    return [];
                }
            },
            placement: {
                type: String,
                default: "bottom-start"
            },
            trigger: {
                type: String,
                default: "click"
            },
            transfer: {
                type: Boolean,
                default: true
            },
            menuClass: String
        },
        data () {
            return {};
        },
        computed: {},
        created () {},
        methods: {
            dispatchEvent (dropdownItem) {
                this.$emit("click", dropdownItem);
            }
        }
    };
</script>

<style lang="less" scoped>
    .DshColorPanel {
        &-rel {
            cursor: pointer;
        }
        &-list {
            font-size: 15px;
            display: flex;
            width: 293px;
            height: 72px;
            flex-wrap: wrap;
            justify-content: space-around;
            align-items: center;
            &-item {
                padding: 6px;
                &-big {
                    width: 15px;
                    height: 15px;
                    display: inline-block;
                    border-radius: 50%;
                }
                &-small {
                    width: 12px;
                    height: 12px;
                    position: absolute;
                    display: inline-block;
                    transform: translate(1.5px,1.5px);
                    border-radius: 50%;
                    &:hover + span{
                        border-width: 1px;
                        border-style: solid;
                    }
                }
            }
        }
    }
</style>
<style lang="less">
    .DshColorPanel {

    }
</style>



// WEBPACK FOOTER //
// node_modules/bri-vtools/src/components/other/DshColorPanel.vue